import React from 'react'
import { RicsSurveyForm } from '../components/survey'
import useMobileLayout from '../hooks/useMobileLayout'
import MobileNewSurvey from '../components/mobile/MobileNewSurvey'

export default function NewSurveyPage() {
  const isMobile = useMobileLayout()

  if (isMobile) {
    return <MobileNewSurvey />
  }

  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">New RICS Home Survey</h1>
        <p className="text-slate-500 mt-1">
          Complete the survey form with property details, inspection findings, and surveyor information
        </p>
      </div>
      <RicsSurveyForm />
    </div>
  )
}
